import { render, staticRenderFns } from "./CreateItem.vue?vue&type=template&id=fe54c620&scoped=true&"
import script from "./CreateItem.vue?vue&type=script&lang=js&"
export * from "./CreateItem.vue?vue&type=script&lang=js&"
import style0 from "./CreateItem.vue?vue&type=style&index=0&id=fe54c620&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe54c620",
  null
  
)

export default component.exports